module.exports = __webpack_public_path__ + "img/mtn_logo.7cf2f65e.svg";